import React from 'react';
import { useHistory } from 'react-router';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Button, TextField, Typography, IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import LoginForm from './schemas/LoginForm';
import { loginEmail } from 'services/authServices';
import AppContext from 'contexts/AppContext';

export default (): JSX.Element => {
  const history = useHistory();
  const { setAuthData } = React.useContext(AppContext);
  const [showErrorMessage, setShowErrorMessage] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: LoginForm(t),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append('email', values.email);
      formData.append('password', values.password);

      const result = await loginEmail(formData);

      if (result) {
        localStorage.setItem('auth-data', JSON.stringify(result));
        setAuthData(result);
        setShowErrorMessage(false);
        history.push('/private/welcome');
      } else {
        setShowErrorMessage(true);
        formik.setSubmitting(false);
      }
    },
  });

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  return (
    <>
      {showErrorMessage && <Typography color="error">{t('incorrect-data-entered')}</Typography>}
      <form onSubmit={formik.handleSubmit}>
        <TextField
          margin="dense"
          fullWidth
          id="email"
          name="email"
          label={t('upper-email')}
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          disabled={formik.isSubmitting}
        />
        <TextField
          margin="dense"
          fullWidth
          id="password"
          name="password"
          label={t('upper-password')}
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          type={showPassword ? 'text' : 'password'}
          disabled={formik.isSubmitting}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword}>
                  {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <div className="footer">
          <Button fullWidth variant="contained" color="primary" type="submit" disabled={formik.isSubmitting}>
            {t('login')}
          </Button>
        </div>
      </form>
    </>
  );
};
